import { ILegendProps } from '../components/base/Legend/models/index.js';
import { ICustomChartProps } from '../models/charting/index.js';
import { IComponentBaseConfiguration } from '../models/IComponentBaseConfiguration.js';
import { IComponentBaseState } from '../models/IComponentBaseState.js';

import { ComponentBase } from './ComponentBase.js';

export abstract class CustomChartBase<
	TProps extends ICustomChartProps,
	TState extends IComponentBaseState,
	TConfiguration extends IComponentBaseConfiguration,
> extends ComponentBase<TProps, TState, TConfiguration> {
	abstract getLegendItems(): ILegendProps['items'];

	get legendProps(): ILegendProps | undefined {
		let result: ILegendProps | undefined;
		const { legend } = this.props;
		if (legend && legend.show) {
			const items: ILegendProps['items'] = legend.items || this.getLegendItems();
			result = { ...legend, items };
		}
		return result;
	}

	get legendPosition(): 'top' | 'bottom' {
		const { legend } = this.props;
		if (legend && legend.show && legend.position) {
			return legend.position;
		}
		return 'bottom';
	}
}
